import {connect} from 'react-redux'
import {ActionsRow, commons, FixedDropDownButton, Icon, Loader, modal, utils} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
import ZpusobDopravyForm from "../../forms/ZpusobDopravyForm";
import TablePanel from "../../components/TablePanel";
import ZmenitPoradiModal from "../../components/ZmenitPoradiModal";
import * as EnumFormaDoruceniInfo from "../../api/EnumFormaDoruceniInfo";
import {toastr} from "react-redux-toastr";
import CustomCheckbox from "../../components/CustomCheckbox";
import {ADMIN_BASE_PATH, DOPRAVA_PATH} from "../../const/routes";
import * as EnumFormaDoruceni from "../../api/gen/cgo/EnumFormaDoruceni";
import * as React from "react";
import {Component} from "react";
import {withTranslation, WithTranslation} from "react-i18next";

const {sinkEvent} = commons;

const COLUMN_WIDTH = 3;

/**
 * Stránka administrace - Doprava
 */
class ZpusobyDopravyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchZpusobyDopravyIfNeeded());
    };

    handleCreateZpusobDopravy = () => {
        const {zpusobyDopravyList, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ZpusobDopravyForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.createZpusobDoprava(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateZpusobyDopravy());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {poradi: zpusobyDopravyList.rows.length + 1}
            },
            t('transport.new'),
            {size: "md"}
        ));
    };

    handleEditZpusobDopravy = (zpusobDopravy) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ZpusobDopravyForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.updateZpusobDoprava(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateZpusobyDopravy());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: zpusobDopravy
            },
            t('transport.change'),
            {size: "md"}
        ));
    };

    handleEditTerminy = (zpusobDopravy) => {
        const {t} = this.props;
        if (zpusobDopravy.formaDoruceni === EnumFormaDoruceni.ADR) {
            this.props.history.push(`/${ADMIN_BASE_PATH}/${DOPRAVA_PATH}/${zpusobDopravy.id}/terminy`);
        } else {
            toastr.error("Termíny lze upravovat pouze pro formu doručení \"" + EnumFormaDoruceniInfo.getCaption(EnumFormaDoruceni.ADR, t) + "\"");
        }
    };

    handleZmenitPoradi = () => {
        const {zpusobyDopravyList, dispatch, t} = this.props;
        if (zpusobyDopravyList.rows.length !== 0) {
            this.props.dispatch(modal.ModalActions.show(
                ZmenitPoradiModal,
                {
                    onOrderChanged: (changedIdsMap) => {
                        CiselnikApi.updatePoradiDopravy(changedIdsMap).then(() => {
                            dispatch(modal.ModalActions.hide());
                            dispatch(ciselnikActions.invalidateZpusobyDopravy());
                        });
                    },
                    items: zpusobyDopravyList.rows,
                    renderItem: i => {
                        return <CardBody key={i.item.id}>
                            <Row>
                                <Col xs={12}>{i.item.nazevDoprava}</Col>
                            </Row>
                        </CardBody>;
                    },
                },
                t('change_in_order'),
                {size: "lg", className: "card-form-modal"}
            ));
        } else {
            toastr.warning("Žádné způsoby dopravy k řazení");
        }
    };

    handleVcetneNeaktivnich = (e) => {
        const {zpusobyDopravyList} = this.props;
        this.props.dispatch(ciselnikActions.filterZpusobyDopravy({
            ...zpusobyDopravyList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    renderContextMenu = (zpusobDopravy) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditZpusobDopravy.bind(this, zpusobDopravy))}>{t('edit')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleEditTerminy.bind(this, zpusobDopravy))}>{t('edit_delivery_time')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {zpusobyDopravyList, t} = this.props;
        let content;
        if (zpusobyDopravyList.fetched) {
            if (zpusobyDopravyList.rows.length !== 0) {
                content = zpusobyDopravyList.rows.map(zpusobDopravy => {
                    return <CardBody key={zpusobDopravy.id} className={zpusobDopravy.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(zpusobDopravy)} onClick={this.handleEditZpusobDopravy.bind(this, zpusobDopravy)}>
                            <Row>
                                <Col xs={COLUMN_WIDTH}>{zpusobDopravy.nazevDoprava}</Col>
                                <Col xs={COLUMN_WIDTH}>{EnumFormaDoruceniInfo.getCaption(zpusobDopravy.formaDoruceni, t)}</Col>
                                <Col xs={COLUMN_WIDTH}>{zpusobDopravy.neaktivni ? t('no') : t('yes')}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('transport.none')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }
        const vcetneNeaktivnich = zpusobyDopravyList.filter.vcetneNeaktivnich || false;
        return <AdminPage
            title={t('transport.one')}
            subtitle={t('transport.system_operator')}
            content={
                <div>
                    <ButtonToolbar>
                        <Button color="primary" onClick={this.handleCreateZpusobDopravy}>{t('new_f')}</Button>
                        <Button color="secondary" onClick={this.handleZmenitPoradi}>{t('change_order')}</Button>
                        <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            <Col xs={COLUMN_WIDTH}>{t('labels.name')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.delivery_form')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('active')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        zpusobyDopravyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_DOPRAVY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(ZpusobyDopravyPage));
